import Constants from '~/config/Constants';

import $store from '~/services/StoreService';
import dayjs from 'dayjs';

export default function profileStatus(to, from, next) {
  const store = $store();
  const user = store.getters['root/userService'];

  // If signup is incomplete, redirect.
  if (user?.occupation === Constants.UserOccupation.CORPORATE
    && !to.path.startsWith('/signup')
  ) {
    window.location.href = '/signup/corporate/1?onboardingState=occupation';
    return;
  }

  // Incomplete paidOrg info
  if (!to.path.startsWith('/onboarding/corporate') && user.isCorporate && user.isPartOfACorporateOrganization && user.isAdmin && !user.corporateOrgName?.trim()) {
    window.location.href = '/onboarding/corporate';
    next();
    return;
  }

  // Corporate Suspected Blocked accounts
  if (user.userData && user.userData.suspectedCorporateAccount) {
    const hardBlockDate = dayjs(user.userData.suspectedCorporateBlockDate).add(7, 'days');
    if (dayjs().isAfter(hardBlockDate) && !to.path.startsWith('/blocked/corporate')) {
      window.location.href = '/blocked/corporate';
      return;
    }
  }

  next();
}
